import { useContext } from 'react';
import type { ApiClient } from '@instanexus/sdk';

import { ApiClientContext } from '@/lib/api-client-context';

/** The injected SDK client. Throws when rendered outside the provider. */
export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (client === null) {
    throw new Error('useApiClient must be used inside an ApiClientContext provider.');
  }
  return client;
}
